export default function Footer() {
    return (
        <footer className="bg-gray-100 p-4 flex items-center text-gray-800 font-inter text-[12px] not-italic font-normal leading-[18px] md:justify-center md:fixed bottom-0 w-full z-50">
            <div>
                © Cosmogas SRL | P.IVA 00810400408 | Società a Socio unico
                soggetta a direzione e coordinamento di Clada Srl
                <a
                    href="https://www.iubenda.com/privacy-policy/42441913"
                    target="_blank"
                    className="mx-1 underline"
                >
                    Privacy
                </a>
                |
                <a
                    href="https://www.iubenda.com/privacy-policy/42441913/cookie-policy"
                    target="_blank"
                    className="mx-1 underline"
                >
                    Cookie
                </a>
            </div>
        </footer>
    );
}